<template>
  <div class="regionForm">

    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="区域编号" prop="fNumber">
        <el-input v-model="form.fNumber" />
      </el-form-item>
      <el-form-item label="区域名称" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>
      <el-form-item label="区域简介">
        <el-input v-model="form.fDes" />
      </el-form-item>
      <template v-if="isEdit">
        <el-form-item label="创建人">
          <el-input :value="form.fCreater" disabled />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input :value="form.fCreateTime | dateTimeFormat" disabled />
        </el-form-item>
        <el-form-item label="最后修改人">
          <el-input v-model="form.fModify" disabled />
        </el-form-item>
        <el-form-item label="最后修改时间">
          <el-input :value="form.fCreateTime | dateTimeFormat" disabled />
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fName: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  computed: {
    isEdit: function() {
      return !!this.form.fRegionID
    }
  },
  mounted: function() {
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" >
.regionForm{
.el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
}
</style>
